<template>
  <div>
    <div class="container">
      <div class="header-title">
        {{ $t('tradingVariety.lang')}}
      </div>

      <div v-for="item in severForm.children" :key="item.name" :class="{'isCheck': idList.includes(item.id)}" class="card" v-if="isCheck">
        <img :src="item.id == 3 ? future : security" class="goods-img" />
        <div class="card-body">
          <div class="title">
            {{ item.name }}
          </div>
          <div class="content">
            {{ item.content }}
          </div>
          <div>
            <Icon v-if="idList.includes(item.id)" :name="bgColor == 'black-theme' ? darkIcon : selectIcon" class="check-mark" size="39" />
          </div>
        </div>
      </div>

      <div v-for="item in severForm.children" :key="item.name" :class="{'isCheck': idList.includes(item.id)}" class="card" v-else @click="handCheck(item.id)">
        <img :src="item.id == 3 ? future : security" class="goods-img" />
        <div class="card-body">
          <div class="title">
            {{ item.name }}
          </div>
          <div class="content">
            {{ item.content }}
          </div>
          <div>
            <Icon v-if="idList.includes(item.id)" :name="bgColor == 'black-theme' ? darkIcon : selectIcon" class="check-mark" size="39" />
          </div>
        </div>
      </div>



      <div class="header-title1">
        {{ $t('tradingVariety.lang0')}}
      </div>
      <div v-for="item in enabledList" :key="item.id" class="card"
           >
        <img :src="item.id == 3 ? future : security" class="goods-img" />
        <div class="card-body">
          <div class="title">
            {{ item.name }}
          </div>
          <div class="content">
            {{ item.content }}
          </div>
        </div>
      </div>


      <div class="foot-btn">
        <nav-buttons @on-next="handRecommend" :disabled="getNextDisabled"></nav-buttons>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, Toast } from "vant";
import Progress from "../components/Progress.vue";
import navButtons from "../components/navButtons.vue";
import selectIcon from "@/assets/images/open-account/select.png";
import future from "@/assets/images/open-account/future.png";
import security from "@/assets/images/open-account/security.png";
import darkIcon from '@/assets/images/open-account/darkChoose.png'


export default {
  components:{
    Icon,
    Progress,
    navButtons
  },
  data(){
    return {
      selectIcon,
      future,
      security,
      darkIcon,
      severForm: {
        children: []
      },
      idList: [],
      enabledList:[],
      isCheck:true
    }
  },
  created() {
    this.handList();
  },
  computed:{
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    getNextDisabled(){
      let btnDisabled = false
      if(this.idList.length == 0){
        btnDisabled = true
      }

      return btnDisabled
    }
  },
  methods:{
    async handList() {
      try {
        await this.$apis.accountServerNewLists().then(res => {
          // 未激活
          if (res && res.disabled_list.length > 0) {
            const { disabled_list } = res
            this.severForm.children = disabled_list[0].children;
          }
          // 已激活
          if (res && res.enabled_list.length > 0) {
            const { enabled_list } = res
            this.enabledList = enabled_list[0].children;
          }
        });
      }catch{

      }
      this.handDetail();

    },
    handDetail() {
      this.$apis.accountSituationV2().then(res => {
        const { config_data } = res?.process_info?.["extra_data"] || {};

        if (Object.keys(config_data).length != 0) {
          const form = JSON.parse(config_data).open_server;
          this.isCheck = true
          if (this.severForm.children.length != 0) {
            this.idList = [Number(form.server_id)];
          }
        }else{
          this.isCheck = false
          const { config_data } = res?.process_info?.["open_server"] || {}
          if (config_data) {
            const form = JSON.parse(config_data);
            if (this.severForm.children.length != 0) {
              this.idList = [Number(form.server_id)];
            }
          }
        }
      });
    },
    handCheck(id) {
      if (this.idList.includes(id)) {
        this.idList = this.idList.filter(item => item != id);
      } else {
        this.idList = [id];
      }
    },
    handRecommend() {
      if (this.severForm.children.length != 0) {
        const server_id = this.idList.join(",");
        const params = {
          process_id:4,
          step_code: 'open_server',
          step_order: 2,
          config_data: {
            server_id
          }
        };
        const toastLoading = Toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: "spinner",
          message: this.$t("common.loading_text")
        });
        this.$apis.supplementSaveApi(params).then(res => {
          if (res) {
            this.$router.push({
              path: '/open-account/investmentExperience',
              query: {
                ...this.$route.query
              }
            }).finally(() => {
              toastLoading.clear();
            });
          }
        });
      }
    }
  }
}
</script>

<style scoped lang="less">
.container{
  padding: 40px;
  .header-title{
    font-size: 36px;
    font-weight: 500;
    color: #17161C;
  }
  .header-title1{
    font-size: 36px;
    font-weight: 500;
    color: #17161C;
    margin-top: 40px;
  }
  .card {
    border-radius: 24px;
    margin-top: 22px;
    background: #F6F7FA;
    display: flex;
    padding: 45px;
    position: relative;
    border: 1px solid transparent;

    .goods-img {
      width: 80px;
      height: 80px;
      object-fit: contain;
    }

    .card-body {
      margin-left: 15px;
      margin-top: -5px;

      .title {
        font-size: 32px;
        font-weight: 500;
        color: #17161C;
      }

      .content {
        font-size: 28px;
        color: #747377;
        margin-top: 10px;
      }

      .check-mark {
        position: absolute;
        bottom: -2px;
        right: -2px;
      }
    }

  }

  .isCheck {
    border: 1px solid #777777;
  }
}
.black-theme{
  .container{
    .header-title{
      color: #FFFFFF;
    }
    .header-title1{
      color: #FFFFFF;
    }
    .card{
      background: #0A0B0F;
      .card-body{
        .title{
          color: #FFFFFF;
        }
        .content{
          color: #9D9D9F;
        }
      }
    }
    .isCheck{
      border: 1px solid #377cfb;
    }
  }
}
</style>
